module.exports = __webpack_public_path__ + "img/exchange.9382463f.png";